<div class="flex flex-col w-[872px] h-[540px] p-16 gap-8">
	<div class="flex justify-center">
		<img
			class="w-auto"
			src="/assets/images/leap/reject-importing.png"
			alt="Reject importing"
		/>
	</div>
	<div class="flex justify-center">
		<h1 class="text-3xl font-medium m-0">
			This Matter Has Not Been Imported Into Closer
		</h1>
	</div>
	<div class="flex">
		<div class="text-center">
			To avoid seeing this message again, change the matter type to
			“Conveyancing” in LEAP, or create a Closer matter using the button below.
		</div>
	</div>
	<div class="flex justify-center">
		<ui-button
			preset="HIGH_EMPHASIS"
			label="Create Closer Matter"
			(click)="closeDialog()"
		></ui-button>
	</div>
</div>
